import './css/styles.scss';

function startsidaHuvudInit() {}

startsidaHuvudInit();
